import { render, staticRenderFns } from "./ApplePayButton.vue?vue&type=template&id=46958a92&scoped=true&"
import script from "./ApplePayButton.vue?vue&type=script&lang=js&"
export * from "./ApplePayButton.vue?vue&type=script&lang=js&"
import style0 from "./ApplePayButton.vue?vue&type=style&index=0&id=46958a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46958a92",
  null
  
)

export default component.exports